<template>
  <div class="stats">
    <b-table
      :data="presentData"
      :columns="columns"
      sticky-header
      height="calc(100vh - 52px)"
    />
  </div>
</template>

<script>
import { stats } from '../../public/wnbasim-latest.json'
import { teams } from '../teams'

export default {
  name: 'Stats',
  data () {
    return {
      stats,
    }
  },
  computed: {
    columns () {
      return Object.keys(stats[0]).map((field) => {
        const opts = {}
        if (field === 'Player') {
          Object.assign(opts, { sticky: true })
        }
        if (field === 'Player' || field === 'Team') {
          Object.assign(opts, { 'cell-class': 'has-text-weight-bold', searchable: true })
        }
        if (typeof stats[0][field] === 'number') {
          Object.assign(opts, { numeric: true })
        }
        return {
          field,
          label: field,
          sortable: true,
          ...opts,
        }
      })
    },
    presentData () {
      return this.stats.filter((row) => row.Player !== null)
    },
    teamsByShortName () {
      const teamMap = {}
      Object.entries(teams).forEach(([, team]) => {
        teamMap[team.short] = team
      })
      return teamMap
    },
  },
}
</script>

<style lang="scss" scoped>
.stats {
  max-height: calc(100% - 52px);
  max-width: 100%;
}

/deep/ .b-table {
  max-height: calc(100% - 52px);
}

/deep/ .table-wrapper {
  max-height: calc(100% - 52px);
}
</style>
